export const TABLE_PAGE_SIZE = 100;
